module.exports = __webpack_public_path__ + "static/media/youtube.fea0933a.png";